<template>
    <StructuralParts></StructuralParts>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const StructuralParts = defineAsyncComponent(() =>
    import("../../components/SupplyChain/StructuralParts.vue")
);
export default {
    name: "SupplyChain_structuralParts", //The name you are in should not equal the name of the component you are importing.
    components: { StructuralParts, AuthLayout },
};
</script>
